// Module
var code = "\n    <div class=\"row-preview\">\n        <p class=\"paragraph_record_field\">{{html ep.common.showHtmlText(Item.Label)}}</p>\n    </div>\n";
// Exports
var htmlContent = code;
jQuery.templatesHtml['#paragraph-record-field'] = htmlContent;
module.exports = "paragraph-record-field";